import {Injectable} from '@angular/core';
import moment from 'moment';
import {DateFormat} from '../../models/enums';

@Injectable({
	providedIn: 'root'
})
export class DateHelperService {

	constructor() {
	}

	static convertDate(date, type: 'start' | 'end' | 'default' | 'forDisplay' = 'default', format: DateFormat = DateFormat.DefaultFormat, useFormat = true) {
		if (!date) {
			return '---';
		}
		let d;
		switch (type) {
			case 'start':
				d = moment(date).startOf('day').format();
				break;
			case 'end':
				d = moment(date).endOf('day').format();
				break;
			case 'default':
				d = useFormat ? moment(date).format(format): moment(date).toISOString();
				break;
		}

		return d;
	}

	static toIonDateTimeLocalISOString(date: Date): string {
		const pad = (n: number) => n.toString().padStart(2, '0');
		return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
	}

	static convertDateAndTime(date, time) {
		let date1 = new Date(date);
		let time1 = new Date(time);

		date1.setHours(time1.getHours());
		date1.setMinutes(time1.getMinutes());

		return date1;
	}

	static dateForSingleDate(date) {
		return {
			start: moment(date).startOf('day').format(DateFormat.DefaultFormat),
			end: moment(date).endOf('day').format(DateFormat.DefaultFormat)
		};
	}

	static tomorrowDate() {
		return moment().add('day');
	}

	static todayPlus30days(needFormat = false, format = DateFormat.DefaultFormat) {
		let d;
		if (needFormat) {
			d = {
				start: moment().startOf('day').format(format),
				end: moment().add(1, 'month').endOf('day').format(format)
			};
		} else {
			d = {
				start: moment().startOf('day').toDate(),
				end: moment().add(1, 'month').endOf('day').toDate()
			};
		}
		return d;
	}

	static datePlus30days(date?: string, format = DateFormat.DefaultFormat) {
		let d;
		d = {
			start: moment(date || new Date()).format(format),
			end: moment(date || new Date()).add(30, 'days').format(format)
		};
		return d;
	}

	static todayMinus30days(needFormat = false) {
		let d;
		if (needFormat) {
			d = {
				start: moment().subtract(1, 'month').startOf('day').format(DateFormat.DefaultFormat),
				end: moment().add(1, 'day').endOf('day').format(DateFormat.DefaultFormat)
			};
		} else {
			d = {
				start: moment().subtract(1, 'month').startOf('day').toDate(),
				end: moment().add(1, 'day').endOf('day').toDate()
			};
		}
		return d;
	}

	static todayPlusMinusYear(needFormat = false) {
		let d;
		if (needFormat) {
			d = {
				start: moment().subtract(1, 'year').startOf('day').format(DateFormat.DefaultFormat),
				end: moment().add(1, 'year').endOf('day').format(DateFormat.DefaultFormat)
			};
		} else {
			d = {
				start: moment().subtract(1, 'year').startOf('day').toDate(),
				end: moment().add(1, 'year').endOf('day').toDate()
			};
		}
		return d;
	}

	static durationInMinutes(date) {
		return moment.duration(moment().diff(date)).asMinutes();
	}

	static isSameDateAsCurrent(dateToCompare, type: 'day' = 'day') {
		return moment().isSame(moment((dateToCompare)), type);
	}

	static isYesterday(dateToCompare, type: 'day' = 'day') {
		return moment().subtract(1, 'day').isSame(moment((dateToCompare)), type);
	}

	static areDateEquals(date1, date2, type: 'day' = 'day') {
		return moment(date1).isSame(moment((date2)), type);
	}

	static isDateLessThan(dateOne, dateTwo) {
		return moment(dateOne).isAfter(moment(dateTwo).add(15, 'minutes'));
	}

	static isDateBetween(startDate, endDate) {
		const currentDate = moment();
		const startDateM = moment(startDate);
		const endDateM = moment(endDate);
		return currentDate.isBetween(startDateM, endDateM);
	}

	static futureYearsList(numberOfYears: number) {
		let year = new Date().getFullYear();
		let dateList = [];
		for (let i = 0; i < numberOfYears; i++) {
			dateList[i] = year + i;
		}
		return dateList;
	}

}
